import { useState, useEffect, Suspense, lazy } from 'react';
import ProfessionalLoader from '../../components/common/ProfessionalLoader';
import api from '../../services/apiService';

// Lazy load ThrowballLayout
const ThrowballLayout = lazy(() => import('../../components/themes/throwball/ThrowballLayout'));

const OfficeBearersPage = () => {
  const [officials, setOfficials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Static/Default data - shown when no dynamic data exists
  const staticOfficeBearers = [
    {
      sno: 1,
      name: "Mr. M. N. Krishnamurthy",
      address: "#3c -910 HRBR,layout Kalyan Nagar Ist block. BANGALURU 560043",
      position: "President",
      contact: "krishnamurthymn19@gmail.com"
    },
    {
      sno: 2,
      name: "Sh. Ashok Sharma",
      address: "2/332, Kalakuan, Housing Board. Alwar-301001, Rajasthan",
      position: "Vice-President",
      contact: "ashok.advocate17@gmail.com"
    },
    {
      sno: 3,
      name: "Ms. Mitali Ghosh",
      address: "H.No. 243 Ward No.-38, Hemu Nagar, Bilaspur (Chhatisgarh) 495001",
      position: "Vice-President",
      contact: "cgabaseball@gmail.com"
    },
    {
      sno: 4,
      name: "Sh. S. Venkat",
      address: "No: 19, 3B, Quanta Ranjini apartments, Rajarathinam Street, Kilpauk, Chennai - 600010",
      position: "Vice-President",
      contact: "tnbachennai@yahoo.co.in"
    },
    {
      sno: 5,
      name: "Sh. S N Pradhan",
      address: "Tala- Telenga Bazar Purighat Cuttack - 753009 ODISHS",
      position: "Vice-President",
      contact: "baseballassociationofodisha@gmail.com"
    },
    {
      sno: 6,
      name: "Mr. Harish Kumar",
      address: "B - 19, 1st floor Sushant lok 2, Behind Police station,Sector - 56 Gurugram - 122011 (Haryana)",
      position: "Secretary General",
      contact: "abfi.secretarygeneral@gmail.com"
    },
    {
      sno: 7,
      name: "Sh. Jahar Dass",
      address: "11/11 Kalicharan Ghosh Road, Kalkata – 700050.",
      position: "Joint Secretary",
      contact: "jaharmumdas@hotmail.com"
    },
    {
      sno: 8,
      name: "Madhu Sharma",
      address: "Shyam Bhawan, Choudhary Tola, Patna 800006. Bihar",
      position: "Joint Secretary",
      contact: "madhusharma731959@gmail.com"
    },
    {
      sno: 9,
      name: "Shweta",
      address: "103,Dhani Apartments, 17-1-388/S/B & C Laxmi Nagar Colony Saidabad, Hyderabad- 500059",
      position: "Joint Secretary",
      contact: "baseballtelangana@gmail.com"
    },
    {
      sno: 10,
      name: "Mr. Virender Bhardwaj",
      address: "A- 401,PLOT NO 15B Maharani Aventi Bai Sector 22 Dwarka New Delhi - 110077",
      position: "Joint Secretary",
      contact: "virenbhardwaj29@gmail.com"
    },
    {
      sno: 11,
      name: "Dr. Dinesh Yadav",
      address: "901, metro suites society sector 4 vaishali ghaziabad (U. P)",
      position: "Treasurer",
      contact: "drdineshyadav1972@gmail.com"
    },
    {
      sno: 12,
      name: "Sh. Raju Shrama",
      address: "House no. 85 sector 1Bhagwati nagar canal road jammu J&K 180001",
      position: "Executive Member",
      contact: "beb83477@gmail.com"
    },
    {
      sno: 13,
      name: "Sh. Dilip Naik",
      address: "A-404, Konkar Nest, Near Agali Estate Housing Co-Op Society, Agali, Fatorda, Margao, Goa-403602",
      position: "Executive Member",
      contact: "dilipnaik0707@gmail.com"
    },
    {
      sno: 14,
      name: "Sh. Arvind Kumar",
      address: "Opp. 191-L, Model Town, Rohatk - 124001",
      position: "Executive Member",
      contact: "balharaharsh@gmail.com"
    },
    {
      sno: 15,
      name: "Mr. Rajendra P.Ikhankar",
      address: "602 Riddhi Siddhi Srusti CHS Plot No 29 Sector 35 Kamothe Panvel Raighad - 410209",
      position: "Executive Member",
      contact: "rikhankar@yahoo.com"
    }
  ];

  useEffect(() => {
    fetchOfficials();
  }, []);

  const fetchOfficials = async () => {
    try {
      setLoading(true);
      const response = await api.get('/public/officials');

      if (response.data.success && response.data.data && response.data.data.length > 0) {
        // Use dynamic data if available
        setOfficials(response.data.data);
      } else {
        // Fallback to static data
        setOfficials(staticOfficeBearers);
      }
    } catch (error) {
      console.error('Error fetching officials:', error);
      // Fallback to static data on error
      setOfficials(staticOfficeBearers);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Suspense fallback={<ProfessionalLoader />}>
      <ThrowballLayout>
        <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize: '32px', marginLeft: '2px', cursor: 'pointer', color: '#2d3e50'}}></i>
        </div>

        <br /><br />

        <div className="col-lg-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <center>
                <label className="bol">
                  Office Bearers<br />
                  LIST OF GOVERNING BODY
                </label>
              </center>
              <br />
            </div>

            <div className="panel-body">
              {loading ? (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <i className="fa fa-spinner fa-spin" style={{ fontSize: '2rem' }}></i>
                  <p>Loading...</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                        <th>Address</th>
                        <th>Position</th>
                        <th>Contact</th>
                      </tr>
                    </thead>
                    <tbody>
                      {officials.map((bearer, index) => (
                        <tr key={bearer.id || index}>
                          <td>{bearer.sno || index + 1}</td>
                          <td>{bearer.name}</td>
                          <td>{bearer.address || '-'}</td>
                          <td>{bearer.position}</td>
                          <td>
                            <span className="glyphicon glyphicon-comment" style={{color: '#7d7d7d'}}></span>
                            {' '}
                            {bearer.contact || bearer.email || '-'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        </div>
      </ThrowballLayout>
    </Suspense>
  );
};

export default OfficeBearersPage;
